<template>
  <section>
    <div class="popups">
      <!-- The modal -->

      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Client:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
            <b-form-group label="Warehouse:">
              <b-v-select
                v-model="formFilters.warehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>
            <b-form-group
              label="From Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.fromDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="fromDate"
              />
            </b-form-group>
            <b-form-group  class="mb-1 pb-2"  label="To Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.toDate"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="toDate"
              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>
    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Inventory Snapshots
            </h1>

            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterWrap(orderType)>
                <span> </span>
              </template>
              <template v-slot:filterVal(projectId)="data">
                <span
                  v-if="myProjects && myProjects.find(a => a.id == data.item)"
                  >{{ myProjects.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item)"
                  >{{ myBrands.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(warehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                  >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :fixed="false"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >

      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(warehouseId)="data">
        <span
          v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.warehouseId)"
          >{{ myWarehouses.find(a => a.id == data.item.warehouseId).name }}</span
        >
        <span v-else>-</span>
      </template>

      <template v-slot:cell(brandId)="data">
        <span
          v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
          >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(warehouseProducts_filePath)="data">
        <div class="d-flex">
          <b-button
            v-if="is('developer')"
            variant="info"
            size="sm"
            class="mr-2"
            @click="downloadSnapshot(data.item.id, 'WarehouseProducts', 'json')"
          >
            .json
          </b-button>
          <b-button
            variant="success"
            size="sm"
            @click="downloadSnapshot(data.item.id, 'WarehouseProducts', 'excel')"
          >
            .xlsx
          </b-button>
        </div>
      </template>

      <template v-slot:cell(storefrontProducts_filePath)="data">
        <div class="d-flex">
          <b-button
            v-if="is('developer')"
            variant="info"
            size="sm"
            class="mr-2"
            @click="downloadSnapshot(data.item.id, 'StorefrontProducts', 'json')"
          >
            .json
          </b-button>
          <b-button
            variant="success"
            size="sm"
            @click="downloadSnapshot(data.item.id, 'StorefrontProducts', 'excel')"
          >
            .xlsx
          </b-button>
        </div>
      </template>

      <template v-slot:cell(warehouseProductLocations_filePath)="data">
        <div class="d-flex">
          <b-button
            v-if="is('developer')"
            variant="info"
            size="sm"
            class="mr-2"
            @click="downloadSnapshot(data.item.id, 'WarehouseProductLocations', 'json')"
          >
            .json
          </b-button>
          <b-button
            variant="success"
            size="sm"
            @click="downloadSnapshot(data.item.id, 'WarehouseProductLocations', 'excel')"
          >
            .xlsx
          </b-button>
        </div>
      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing, ActiveFiltersCard } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'InventorySnapshots.Index',
  mixins: [crudMixinGen('inventorySnapshots'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },

  data: () => ({
    fields: [
      { key: 'createDateTimeUtc', label: 'When', sortable: true },
      { key: 'brandId', label: 'Client', sortable: true },
      { key: 'warehouseId', label: 'Warehouse', sortable: true },
      { key: 'warehouseProducts_filePath', label: 'Warehouse Items', sortable: true },
      { key: 'storefrontProducts_filePath', label: 'Storefront Products', sortable: true },
      { key: 'warehouseProductLocations_filePath', label: 'By Location Inv.', sortable: true },
    ]
  }),

  mounted() {
    this.loadItems();
  },

  methods: {
    downloadSnapshot(snapshotId, type, format) {
      const downloadUrl = format === 'json'
        ? this.$store.getters.getAppUrl + '/download/inventorySnapshot/json/' + snapshotId + '/' + type
        : this.$store.getters.getAppUrl + '/download/inventorySnapshot/excel/' + snapshotId + '/' + type;

      this.$http.get(downloadUrl, {
        responseType: 'blob'
      })
        .then(response => {
          const href = window.URL.createObjectURL(response.data);
          const fileExtension = format === 'json' ? 'json' : 'xlsx';
          const fileName = 'InventorySnapshot_' + snapshotId + '_' + type + '.' + fileExtension;
          const anchorElement = document.createElement('a');

          anchorElement.href = href;
          anchorElement.download = fileName;

          document.body.appendChild(anchorElement);
          anchorElement.click();

          document.body.removeChild(anchorElement);
          window.URL.revokeObjectURL(href);
        })
        .catch(error => {
          this.$swal('Error', 'Error downloading file', 'error');
          console.log('error: ', error);
        });
    }
  }
};
</script>
